import { inject, Injectable } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { CarsWidgetFormType } from '@com-delta-idp/mnx-sitewide-header-ui';
import { AppConfigService } from '@com-delta-idp/mnx-sitewide-shared-core-smart';

@Injectable({ providedIn: 'root' })
export class BookingCarsFormService {
  private appConfigService = inject(AppConfigService);
  createBookingForm(): FormGroup<CarsWidgetFormType> {
    return new FormGroup({
      locationCode: new FormControl<string | null>(null, Validators.required),
      pickUpDate: new FormControl<Date | null>(null, Validators.required),
      pickUpTime: new FormControl<string | null>('10:00', Validators.required),
      dropOffDate: new FormControl<Date | null>(null, Validators.required),
      dropOffTime: new FormControl<string | null>('10:00', Validators.required)
    });
  }

  private formatDate1(date: Date): string {
    const month = date.getMonth() + 1;
    const day = date.getDate();
    const year = date.getFullYear();
    return `${month}/${day}/${year}`;
  }

  private formatDate2(date: Date): string {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  private formatTime(time: string): string {
    if (!time) return '1000AM';
    if (this.hasAmPm(time)) return time.replace(':', '');

    const [hours, minutes = '00'] = time.split(':');
    const hour = parseInt(hours, 10);
    if (isNaN(hour)) return '1000AM';

    return this.convertTo12Hour(hour, minutes);
  }

  private hasAmPm(time: string): boolean {
    return time.includes('AM') || time.includes('PM');
  }

  private convertTo12Hour(hour: number, minutes: string): string {
    const hour12 = this.get12HourFormat(hour);
    const period = this.getPeriod(hour);
    return `${String(hour12).padStart(2, '0')}${minutes}${period}`;
  }

  private get12HourFormat(hour: number): number {
    if (hour === 0) return 12;
    if (hour > 12) return hour - 12;
    return hour;
  }

  private getPeriod(hour: number): string {
    return hour >= 12 ? 'PM' : 'AM';
  }

  navigateToCarsSearch(
    formData: {
      pickUpDate: Date;
      dropOffDate: Date;
      pickUpTime: string;
      dropOffTime: string;
    },
    airportCode: string,
    gaiaId: string
  ): void {
    const isValidIATACode = airportCode && /^[A-Z]{3}$/.test(airportCode);
    const time1 = this.formatTime(formData.pickUpTime);
    const time2 = this.formatTime(formData.dropOffTime);
    const date1 = this.formatDate1(formData.pickUpDate);
    const date2 = this.formatDate1(formData.dropOffDate);
    const d1 = this.formatDate2(formData.pickUpDate);
    const d2 = this.formatDate2(formData.dropOffDate);
    const pickupCode = isValidIATACode ? airportCode : '';

    this.appConfigService
      .getConfigValue('HEADER', 'CARS_SEARCH_URL')
      .subscribe((baseUrl) => {
        const url = `${baseUrl}?time1=${time1}&time2=${time2}&dpln=${gaiaId}&pickupIATACode=${pickupCode}&date2=${date2}&date1=${date1}&MDPCID=Delta.Site.US.HomepageWidget.Cars.WidgetTestWhite&d1=${d1}&returnIATACode=&d2=${d2}#.`;
        window.open(url, '_blank');
      });
  }
}
